import type { SVGProps } from 'react';

const SvgJpFontSizeMFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M12.6838 20.1521C12.6838 20.2961 12.6118 20.3681 12.4678 20.3681H11.4778C11.3338 20.3681 11.2618 20.2961 11.2618 20.1521V15.6341H4.88983C4.74583 15.6341 4.67383 15.5621 4.67383 15.4181V7.30008C4.67383 7.15608 4.74583 7.08408 4.88983 7.08408H11.2618V4.15008C11.2618 4.00608 11.3338 3.93408 11.4778 3.93408H12.4678C12.6118 3.93408 12.6838 4.00608 12.6838 4.15008V7.08408H19.0918C19.2358 7.08408 19.3078 7.15608 19.3078 7.30008V15.4181C19.3078 15.5621 19.2358 15.6341 19.0918 15.6341H12.6838V20.1521ZM11.2618 14.2121V8.50608H6.00583V14.2121H11.2618ZM17.9758 14.2121V8.50608H12.6838V14.2121H17.9758Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgJpFontSizeMFilled;
